import * as React from 'react';
import RefIcon$4 from '../../../../@ant-design/icons/es/icons/CaretDownFilled.js';
import RefIcon$1 from '../../../../@ant-design/icons/es/icons/FileOutlined.js';
import RefIcon from '../../../../@ant-design/icons/es/icons/LoadingOutlined.js';
import RefIcon$2 from '../../../../@ant-design/icons/es/icons/MinusSquareOutlined.js';
import RefIcon$3 from '../../../../@ant-design/icons/es/icons/PlusSquareOutlined.js';
import classNames from './../../../external_lib/classnames/index.js';
import { cloneElement } from '../../_util/reactNode.js';
const SwitcherIconCom = props => {
  const {
    prefixCls,
    switcherIcon,
    treeNodeProps,
    showLine
  } = props;
  const {
    isLeaf,
    expanded,
    loading
  } = treeNodeProps;
  if (loading) {
    return /*#__PURE__*/React.createElement(RefIcon, {
      className: `${prefixCls}-switcher-loading-icon`
    });
  }
  let showLeafIcon;
  if (showLine && typeof showLine === 'object') {
    showLeafIcon = showLine.showLeafIcon;
  }
  if (isLeaf) {
    if (!showLine) {
      return null;
    }
    if (typeof showLeafIcon !== 'boolean' && !!showLeafIcon) {
      const leafIcon = typeof showLeafIcon === 'function' ? showLeafIcon(treeNodeProps) : showLeafIcon;
      const leafCls = `${prefixCls}-switcher-line-custom-icon`;
      if ( /*#__PURE__*/React.isValidElement(leafIcon)) {
        return cloneElement(leafIcon, {
          className: classNames(leafIcon.props.className || '', leafCls)
        });
      }
      return leafIcon;
    }
    return showLeafIcon ? /*#__PURE__*/React.createElement(RefIcon$1, {
      className: `${prefixCls}-switcher-line-icon`
    }) : /*#__PURE__*/React.createElement("span", {
      className: `${prefixCls}-switcher-leaf-line`
    });
  }
  const switcherCls = `${prefixCls}-switcher-icon`;
  const switcher = typeof switcherIcon === 'function' ? switcherIcon(treeNodeProps) : switcherIcon;
  if ( /*#__PURE__*/React.isValidElement(switcher)) {
    return cloneElement(switcher, {
      className: classNames(switcher.props.className || '', switcherCls)
    });
  }
  if (switcher !== undefined) {
    return switcher;
  }
  if (showLine) {
    return expanded ? /*#__PURE__*/React.createElement(RefIcon$2, {
      className: `${prefixCls}-switcher-line-icon`
    }) : /*#__PURE__*/React.createElement(RefIcon$3, {
      className: `${prefixCls}-switcher-line-icon`
    });
  }
  return /*#__PURE__*/React.createElement(RefIcon$4, {
    className: switcherCls
  });
};
var SwitcherIconCom$1 = SwitcherIconCom;
export { SwitcherIconCom$1 as default };
//# sourceMappingURL=iconUtil.js.map
